'use client';

import { useState } from 'react';
import Script from 'next/script';
import { LoadingIndicator } from '@petsmart-ui/sparky';
import { getENV } from '@libs/common-next';

import './LocalAd.scss';

export function LocalAd() {
    const [isLoading, setIsLoading] = useState(true);
    const flippMerchantId = getENV('NEXT_PUBLIC_FLIPP_MERCHANT_ID');
    const scriptUrl = `https://aq.flippenterprise.net/${flippMerchantId}/iframe.js`;

    return (
        <>
            <Script
                src={scriptUrl}
                id="flipp-storefront-script"
                onLoad={() => setIsLoading(false)}
                onError={() => setIsLoading(false)}
            />
            <Script strategy="lazyOnload" id="flipp">
                {`var flippContainer = document.querySelector("#flipp-container");
                var storefront = new Flipp.Storefront({
                    accessToken: "${getENV('NEXT_PUBLIC_FLIPP_ACCESS_TOKEN')}",
                    merchantId: "${getENV('NEXT_PUBLIC_FLIPP_MERCHANT_ID')}",
                    merchantNameIdentifier: "${getENV(
                        'NEXT_PUBLIC_FLIPP_MERCHANT_NAME'
                    )}",
                    locale: "en-CA"
                });
                storefront.renderStorefront(flippContainer);`}
            </Script>
            <div id="flipp-container" />
            {isLoading && (
                <div className="local-ad">
                    <LoadingIndicator iconSize="xl" />
                </div>
            )}
        </>
    );
}
